import { Component, OnDestroy, inject } from '@angular/core';
import { ModalController, ViewWillEnter } from '@ionic/angular';

// Types
import { FailedCall } from '../../types/manageCalls';

// Http
import { ApiService } from '../../../core/http/api.service';

// Services
import { CommonService } from '../../../core/services/common/common.service';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { LoggerService } from '../../../core/services/logger/logger.service';
import { NetworkService } from '../../../core/services/network/network.service';
import { TranslationService } from '../../../core/services/translation/translation.service';
import { WsErrorService } from '../../../core/services/ws-error/ws-error.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.page.html',
  styleUrls: ['../../../../styles/page.preset.style.scss'],
  standalone: false,
})
export class TermsAndConditionsPage implements ViewWillEnter, OnDestroy {
  translate = inject(TranslationService);
  wsError = inject(WsErrorService);
  private api = inject(ApiService);
  private common = inject(CommonService);
  private loaders = inject(LoaderService);
  private logger = inject(LoggerService);
  private modalCtrl = inject(ModalController);
  private network = inject(NetworkService);

  public termsAndConditionsLanguage: string;

  private refusedTermsAndConditions: boolean;

  get isBlockedApp(): boolean {
    return this.network.blockedApp;
  }

  get isInternetAvailable(): boolean {
    return this.network.connected;
  }

  get hasRefusedTermsAndConditions(): boolean {
    return this.refusedTermsAndConditions;
  }

  get TERMS_AND_CONDITIONS_TEXT(): string {
    if (this.termsAndConditionsLanguage) {
      if (this.common?.configFile?.TERMS_AND_CONDITIONS) {
        return this.common.configFile.TERMS_AND_CONDITIONS[
          this.termsAndConditionsLanguage.toUpperCase() as 'IT' | 'EN'
        ];
      }
    }
  }

  ionViewWillEnter(): void {
    this.termsAndConditionsLanguage = this.common.currentLang ?? 'en';
    this.refusedTermsAndConditions = false;

    this.wsError.removeWebServiceError();
  }

  ngOnDestroy(): void {
    this.network.removeListeners('TermsAndConditionsPage');
  }

  acceptTermsAndConditions(): void {
    void this.loaders.dismiss();

    this.api.appFunctionalities
      .acceptTermsAndConditions()
      .subscribe({
        next: () => {
          void this.loaders.dismiss();
          void this.modalCtrl.dismiss(null, 'ok');
        },
        error: ({ error }: FailedCall) => {
          this.loaders.dismiss();

          this.logger.consoleError('TermsAndConditionsPage', 'acceptTermsAndConditions', 'setWebServiceError');
          this.wsError.setWebServiceError(error, false, false, false);
        },
      })
      .add(() => this.loaders.dismiss());
  }

  rejectTermsAndConditions(): void {
    this.refusedTermsAndConditions = true;
  }

  removeRefusedTermsAndConditions(): void {
    this.refusedTermsAndConditions = false;
  }

  changeLanguage(): void {
    const langToSet = this.termsAndConditionsLanguage;
    this.translate.setCurrentLanguage(langToSet);
  }
}
